export default "__VITE_ASSET__DVYUJoBa__"